import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
//import { UpdateService } from './services/update.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SettingsService } from './services/settings.service';
import { Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './auth/service/user.service';
import { PreviewService } from './services/preview.service';
import { UpdateService } from './services/update.service';
import { AuthService } from './auth/service/auth.service';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from './services/analytics.service';
import { SocialAuthService } from '@abacritt/angularx-social-login';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'scenario-library';
  private userData: any;
  public showPreview = false;
  public socialAuthSub!: Subscription;
  private siteStatus = 1;


  constructor(
    private sw: UpdateService,
    private router: Router,
    private titleService: Title,
 //   private ccService: NgcCookieConsentService,
    private authService: AuthService,
    private viewportScroller: ViewportScroller,
    private settingsService: SettingsService,
    private analyticsService: AnalyticsService,
    public vcRef: ViewContainerRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    private cookieService: CookieService,
    private userService: UserService,
    private previewService: PreviewService,
    private socialAuthService: SocialAuthService,
    private activatedRoute: ActivatedRoute,
  ) {
    // check the service worker for updates
    this.sw.checkForUpdates();
  }

  ngOnInit() {

    this.socialAuthSub = this.socialAuthService.authState.subscribe((user:any) => {
      // listen to social logins
      switch (user.provider) {
        case 'GOOGLE':
          this.authService.authGoogle(user.email, user.idToken).subscribe(
            (resData:any) => {
              // do they need to evaluate?
              this.router.navigate(['/dashboard']);
            },
            (errorMessage:any) => {}
          );
          break;
      }
    });
    // try and restpore session
    let isAuthed = this.cookieService.get('appAuthed');
    if (isAuthed) {
      this.authService.restore().subscribe(
        (restoreResponsedata: any) => {
          if (this.router.url.split('?')[0] === '/login') {
            if (this.authService.redirect) {
              this.router.navigateByUrl(this.authService.redirect);
            } else {
              this.router.navigate(['/']);
            }
          }
        },
        (errorMessage: any) => {}
      );
    } else {
      const appEmail = this.cookieService.get('appEmail');
      const appToken = this.cookieService.get('appToken');

      if (appEmail && appToken) {
        // try autologin here?
        this.authService.autoLogin()?.subscribe(
          (resData: any) => {
            if (this.router.url.split('?')[0] === '/login') {
              if (this.authService.redirect) {
                this.router.navigateByUrl(this.authService.redirect);
              } else {
                this.router.navigate(['/dashboard']);
              }
            }
          },
          (errorMessage: any) => {
            // console.log(errorMessage);
          }
        );
      }
    }

    this.userService.userData.subscribe((userData: any) => {
      if (userData) {
        this.userData = userData;
      }
    });

    // scroll to top on route change
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (this.siteStatus === 0 && this.router.url != '/offline') {
        this.router.navigate(['/offline']);
      }
      window.scrollTo(0, 0);

      // set page title
      const title = this.getTitle(
        this.router.routerState,
        this.router.routerState.root
      ).join(' | ');
      this.titleService.setTitle(environment.title + ' | ' + title);
      this.analyticsService.trackVirtualPageview(
        environment.title + ' | ' + title
      );

      // do we need the body class?
      if (this.activatedRoute.snapshot.data['hideNavbar']) {
        this.renderer.addClass(document.body, 'no-navbar');
      }
    });
  }


  getTitle(state: any, parent: any): any {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.pageTitle) {
      data.push(parent.snapshot.data.pageTitle);
    }

    if (parent && parent.snapshot.data && parent.snapshot.data.subTitle) {
      data.push(parent.snapshot.data.subTitle);
    }

    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  ngOnDestroy() {

  }
}

